import { Spinner } from "../../components/Layout";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

export const FormSpinner = (props) => {

  const {openFormSpinner, closeFormSpinner} = props;

    return (
        <Dialog
        open={openFormSpinner}
        onClose={closeFormSpinner}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth
        disableEscapeKeyDown="true"
      >
        <DialogTitle id="alert-dialog-title"></DialogTitle>
        <DialogContent>
          <div className="d-flex w-100 justify-content-center align-items-center">
            <Spinner
              accessibilityLabel="Loading"
              className="uxf-spinner-border-lg"
              animation="border"
            />
          </div>
        </DialogContent>
      </Dialog>
    );
}